import React, { useState, useRef, useEffect } from "react";
import {
  VStack,
  HStack,
  Text,
  Box,
  Button,
  Input,
  Image,
  Pressable,
  Icon,
  IconButton,
} from "native-base";
import inform from "../../../assets/images/inform.png";
import { DollarCoinsIcon } from "../../../assets/icons/icon-assets";
import { CloseIcon, SearchIcon } from "native-base";
import { useParams, useNavigate } from "react-router-dom";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setSearch, setUser } from "../../../Redux/Actions/userActions";
import * as AV from "../../../AVCore/AVCore";
import AVInputtext from "../../../components/AVInputtext";
import _ from "lodash";
import { Loc } from "../../../App/Loc";
import AVBody from "../../../components/common/AVBody";
import ProfilePic from "../../common/ProfilePicture";
import { PageLoader } from "../../../components/loaders";
import EntityProfilePic from "../../common/EntityProfilePic";

declare function appendHelcimPayIframe(
  checkoutToken: string,
  showImmediately: boolean,
): void;

interface PaymentMessageData {
  hash: string;
  data: {
    amount: number | string;
    [key: string]: unknown;
  };
}

interface PaymentData {
  checkoutToken: string;
  data: PaymentMessageData;
}

function Donate({}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentUser = useSelector(
    (state: RootStateOrAny) => state?.user?.user[0],
  ) as AV.IAVEntity;
  const entityDataList = useSelector(
    (state: RootStateOrAny) => state.user.entitydatalist,
  );
  const [pageLoader, setPageLoader] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState("$3");
  const [showOtherAmount, setShowOtherAmount] = useState(false);
  const [customAmount, setCustomAmount] = useState<string>("");
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [suggestions, setSuggestions] = useState<AV.ILink[]>([]);
  const [selectedTeam, setSelectedTeam] = useState<AV.ILink | null>(null);
  const [isSearching, setIsSearching] = useState(false);
  const [isLoadingBuy, setIsLoadingBuy] = React.useState(false);
  const localUserSearch = useSelector(
    (state: RootStateOrAny) => state.user.userSearch,
  );
  const [entity, setEntity] = useState<AV.IAVEntity | null>(null);
  const [creditsAvailable, setCreditsAvailable] = useState<number>(
    entity ? (entity?.plan?.credits ?? 0) : (currentUser?.plan?.credits ?? 0),
  );
  const [searchResults, setSearchResults] = useState<AV.ILink[]>([]);
  const [isMinValidate, setIsMinValidate] = useState(false);
  const [IsOpenConvo, setIsOpenConvo] = useState(false);
  const [convoData, setIsConvoData] = useState(false);
  const [createType, setCreateType] = useState<string>("");
  const [showCreateNewPage, setShowCreateNewPage] = useState<boolean>(false);
  const [showEdit, setIsShowEdit] = useState(false);
  const [sharedPlan, setSharedPlan] = React.useState<AV.ISharedPlan>();
  let Fk = AV.AVEntity.getFk(entity ? entity : currentUser);

  const handleSearchItems = async (searchValue: string) => {
    setSearchQuery(searchValue);

    if (searchValue.length >= 1) {
      try {
        // Get search results from AV.Person.search
        const searchData = await AV.Person.localSearch(searchValue);
        let results = (searchData || []) as AV.ILink[];

        // Filter and transform the results
        results = results.filter(
          (x) =>
            x?.title !== undefined &&
            x?.data !== "Deleted" &&
            x?.data !== "Suspended" &&
            x.type != "Channel" &&
            //x.type != "Person" &&
            (x?.title?.toLowerCase().includes(searchValue.toLowerCase()) ||
              x?.data?.toLowerCase().includes(searchValue.toLowerCase())),
        );

        // Remove blocked users and channels
        results = results.filter(
          (x) => !currentUser?.blocked?.some((y: AV.ILink) => y?.id === x?.id),
        );

        // Remove duplicates and format for display
        const formattedResults = _.uniqBy(results, "id");

        setSearchResults(formattedResults);
        setSuggestions(formattedResults);

        let locSearch = localUserSearch;
        if (locSearch == undefined) locSearch = [];
        locSearch = locSearch.concat(results);
        locSearch = locSearch?.filter(
          (x) => !currentUser?.blocked?.some((y) => y?.id === x?.id),
        );
        locSearch = _.uniqBy(locSearch, "id");
        dispatch(setSearch(locSearch));
      } catch (error) {
        console.error("Error searching teams:", error);
        setSearchResults([]);
        setSuggestions([]);
      }
    } else {
      setSearchResults([]);
      setSuggestions([]);
    }
  };

  const handleTeamSelect = async (team: AV.ILink) => {
    setSelectedTeam(team);
    localStorage.setItem("selectedTeam", JSON.stringify(team));
    setSearchQuery(team.title ?? "");
    setSuggestions([]);
    setSearchResults([]);

    const fk = AV.AVEntity.getFk(team as AV.IAVEntity);

    try {
      const [entity, sharedPlan] = (await Promise.all([
        AV.AVEntity.get(fk),
        AV.AVEntity.getSharedPlan(fk),
      ])) as [AV.IAVEntity, AV.ISharedPlan];

      if (entity) setEntity(entity);
      setSharedPlan(sharedPlan);
      setCreditsAvailable(entity?.plan?.credits ?? 0);
    } catch (error) {
      console.error("Error fetching entity or sharedPlan:", error);
    }
  };

  const clearSearch = async () => {
    setSearchQuery("");
    setSuggestions([]);
    setSearchResults([]);
    setSelectedTeam(null);
    setIsSearching(false);
    setEntity(null);
    localStorage.removeItem("selectedTeam");
    setCreditsAvailable(
      entity ? (entity?.plan?.credits ?? 0) : (currentUser?.plan?.credits ?? 0),
    );

    //const fk = AV.AVEntity.getFk(currentUser);
    //try {
    //  const sharedPlan: AV.ISharedPlan = await AV.AVEntity.getSharedPlan(fk);
    //  setSharedPlan(sharedPlan);
    //  setCreditsAvailable(sharedPlan?.plan?.credits ?? 0);
    //} catch (error) {
    //  console.error("Failed to fetch sharedPlan:", error);
    //}
  };

  const handleDonate = async () => {
    try {
      setIsLoadingBuy(true);
      // Determine the amount
      const amount =
        selectedAmount === Loc.currentLang.activity.other
          ? parseFloat(customAmount)
          : parseFloat(selectedAmount.replace("$", ""));

      if (isNaN(amount) || amount <= 0) {
        throw new Error("Invalid amount selected.");
      }

      // Construct CollectOptions
      const collectOptions: AV.ICollectOptions = {
        collectReason: "D", // "D" for Donation
        personAmount: amount,
        currency: "USD",
        collectType: "Members",
        showPersonResults: false,
        trackByPerson: false,
        chargeFee: false,
        perPersonFee: false,
        target: selectedTeam
          ? AV.AVEntity.getLink(selectedTeam as AV.IAVEntity)
          : AV.AVEntity.getLink(currentUser as AV.IAVEntity),
        //package: '50GBM'
      };

      // Get payment token
      const token = await AV.Pay.createPayment(collectOptions);

      if (token) {
        // Initialize Helcim payment
        await initHelcimPayment(
          token,
          amount,
          currentUser?.email || "",
          currentUser?.name || "",
        );
      } else {
        setIsLoadingBuy(false);
        throw new Error("Failed to create payment token");
      }
      setIsLoadingBuy(false);
    } catch (error) {
      console.error("Error creating payment:", error);
    }
  };

  //#region HelcimPayment Section

  // Add these variables at component level
  const [initData, setInitData] = useState<AV.IPayInitResp | null>(null);
  const [verify, setVerify] = useState<AV.IPayResultResp | null>(null);
  const tokenRef = useRef<string | null>(null);

  // Use ref to keep latest initData for use in event listener
  const initDataRef = useRef<AV.IPayInitResp | null>(null);
  useEffect(() => {
    initDataRef.current = initData;
  }, [initData]);

  // NOTE: Add Helcim script only once globally (public/index.html) – avoid TOKEN_LENGTH redeclare error.

  // Add event listener once on mount
  useEffect(() => {
    window.addEventListener("message", handleHelcimResponse);
    return () => {
      window.removeEventListener("message", handleHelcimResponse);
    };
  }, []);

  const initHelcimPayment = async (
    token: string,
    amount: number,
    email: string,
    name: string,
  ) => {
    try {
      setPageLoader(true);
      tokenRef.current = token;

      const response = await fetch("/api/pay/HInit", {
        method: "POST",
        headers: {
          accept: "application/json",
          "content-type": "application/json",
        },
        body: JSON.stringify({ token, amount, email, name }),
      });

      const data = await response.json();
      setInitData(data); // update state
      initDataRef.current = data; // keep ref in sync

      appendHelcimPayIframe(data.checkoutToken, true);

      setTimeout(() => {
        setPageLoader(false);
      }, 5000);
    } catch (error) {
      console.error("Payment initialization failed:", error);
      setPageLoader(false);
      throw error;
    }
  };

  const handleHelcimResponse = async (event: MessageEvent) => {
    const currentInitData = initDataRef.current;
    if (!currentInitData) return;

    const expectedKey = "helcim-pay-js-" + currentInitData.checkoutToken;

    if (event.data.eventName === expectedKey) {
      const status = event.data.eventStatus;
      const message = event.data.eventMessage;

      if (status === "ABORTED") {
        console.warn("Transaction aborted:", message);
      }

      if (status === "SUCCESS") {
        console.log("Transaction success:", message);
        try {
          const response = JSON.parse(message).data;

          await handlePaymentResult({
            checkoutToken: currentInitData.checkoutToken,
            data: response,
          });
        } catch (err) {
          console.error(
            "Failed parsing or handling Helcim success message:",
            err,
          );
        }
      }
    }
  };

  const handlePaymentResult = async (paymentData: PaymentData) => {
    try {
      const payload = {
        token: tokenRef.current ?? "",
        checkoutToken: paymentData.checkoutToken,
        data: {
          hash: paymentData.data.hash,
          data: JSON.stringify(paymentData.data.data),
        },
      };

      const response = await fetch("/api/pay/HResult", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();
      console.log("Payment verification result:", result);
      setVerify(result);

      if (result?.status === "OK") {
        console.log("Payment verified successfully");
      } else {
        console.warn("Payment verification failed on backend");
      }
      setCustomAmount("");
      setSelectedAmount("$3");
      setShowOtherAmount(false);

      const storedTeam = localStorage.getItem("selectedTeam");
      if (storedTeam) {
        const team = JSON.parse(storedTeam);
        setSelectedTeam(team);
        setSearchQuery(team.title);

        const fk = AV.AVEntity.getFk(team);

        try {
          const [entity, sharedPlan] = (await Promise.all([
            AV.AVEntity.get(fk),
            AV.AVEntity.getSharedPlan(fk),
          ])) as [AV.IAVEntity, AV.ISharedPlan];

          if (entity) setEntity(entity);
          setSharedPlan(sharedPlan);
          setCreditsAvailable(
            entity
              ? (entity?.plan?.credits ?? 0)
              : (currentUser?.plan?.credits ?? 0),
          );
        } catch (error) {
          console.error("Error fetching entity or sharedPlan:", error);
        }

        localStorage.removeItem("selectedTeam");
      } else if (currentUser?.plan) {
        const updatedCurrentUser = { ...currentUser };
        const currentPlan = updatedCurrentUser.plan;
        updatedCurrentUser.plan = {
          credits:
            (currentPlan?.credits || 0) +
            (Number(paymentData.data.data.amount) * 5000 - 2000 || 0),
          storeLimit: currentPlan?.storeLimit ?? 0,
          baseStoreLimit: currentPlan?.baseStoreLimit ?? 0,
          payStoreEndDate: currentPlan?.payStoreEndDate ?? new Date(),
          topEntities: currentPlan?.topEntities ?? 0,
          storeUsed: currentPlan?.storeUsed ?? 0,
          shared: currentPlan?.shared ?? { id: "" },
        };

        dispatch(setUser(updatedCurrentUser));
      }

      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    } catch (error) {
      console.error("Payment verification failed (frontend):", error);
      // Remove the HelcimPay.js iframe from the DOM
      const iframe = document.querySelector("iframe[src*='helcim']");
      if (iframe && iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }
  };

  //#endregion HelcimPayment Section

  useEffect(() => {
    let isMounted = true; // flag to prevent state updates on unmounted component

    const loadSharedPlan = async () => {
      try {
        const sharedPlan: AV.ISharedPlan = await AV.AVEntity.getSharedPlan(Fk);
        if (isMounted) {
          setSharedPlan(sharedPlan);
          setCreditsAvailable(
            entity
              ? (entity?.plan?.credits ?? 0)
              : (currentUser?.plan?.credits ?? 0),
          );
        }
      } catch (error) {
        if (isMounted) {
          console.error("Failed to load sharedPlan:", error);
        }
      }
    };

    loadSharedPlan();

    if (entity !== undefined && isMounted) {
      setEntity(entity);
    }

    return () => {
      isMounted = false;
    };
  }, [entity, currentUser]);

  return (
    <AVBody
      passEntity={undefined}
      setPassEntity={undefined}
      isOpenConvo={IsOpenConvo}
      isConvoData={""}
      setIshuddleData={undefined}
      setIsOpenConvo={setIsOpenConvo}
      setIsConvoData={setIsConvoData}
      setCreateType={setCreateType}
      createType={createType}
      setShowCreateNewPage={setShowCreateNewPage}
      showCreateNewPage={showCreateNewPage}
      setIsShowEdit={setIsShowEdit}
    >
      {pageLoader && (
        <Box
          position="fixed"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bgColor="#F5F4F1"
          justifyContent="center"
          alignItems="center"
          zIndex={9999}
        >
          <HStack
            space={3}
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="300px"
          >
            <PageLoader />
          </HStack>
        </Box>
      )}

      <Box
        p={8}
        bg="white"
        borderRadius="xl"
        maxW="800px"
        mx="auto"
        mt={1}
        //height="calc(100vh - 150px)"
        overflow="auto"
        position="relative"
      >
        <Box>
          {/* Header */}
          <HStack justifyContent="space-between" alignItems="center" mb={8}>
            <Text fontSize="2xl" fontWeight="bold">
              {selectedTeam
                ? `${Loc.currentLang.menu.donate} ${Loc.currentLang.menu.to} ${selectedTeam.title}`
                : Loc.currentLang.menu.donate}
            </Text>

            <HStack space={2} alignItems="center">
              <Text>{Loc.currentLang.purchaseCredits.Credits}</Text>
              <Box bg="yellow.100" px={3} py={1} borderRadius="full">
                <HStack space={1} alignItems="center">
                  <DollarCoinsIcon height="15px" width="15px" />
                  <Text>{creditsAvailable ?? "0"}</Text>
                </HStack>
              </Box>
            </HStack>
          </HStack>

          {/* Main Content */}
          <HStack
            space={8}
            alignItems="flex-start"
            mb={4}
            flexDirection={{ base: "column", md: "row" }}
          >
            {/* Left Side: Image and Text */}
            <VStack
              flex={1}
              space={4}
              minW={{ base: "100%", md: "45%" }}
              mt={{ base: 0, md: 4 }}
            >
              {/* Image */}
              <Image
                source={require("../../../assets/images/donation-illustration.png")}
                alt="Donation Illustration"
                width="100%"
                height="200px"
                resizeMode="contain"
              />

              {/* Text Content Below Image */}
              <VStack space={2}>
                <Text fontSize="xl" fontWeight="semibold">
                  {Loc.currentLang.donate["thankYou!"]}
                </Text>
                <Text color="gray.600" fontSize="md">
                  {Loc.currentLang.donate.donateInfo}
                </Text>
                {/*<Text color="gray.600" fontSize="md">*/}
                {/*  {Loc.currentLang.donate.donateThank}*/}
                {/*</Text>*/}
              </VStack>
            </VStack>

            {/* Right Side: Amount Selection */}
            <Box flex={1} minW={{ base: "100%", md: "45%" }}>
              {/* Team Search */}
              {(isSearching || selectedTeam) && (
                <Box mb={6} position="relative" zIndex={2}>
                  <HStack space={2} alignItems="center">
                    <Input
                      flex={1}
                      placeholder={Loc?.currentLang?.menu?.search}
                      value={searchQuery}
                      onChangeText={handleSearchItems}
                      size="lg"
                      borderRadius="md"
                      borderColor="gray.200"
                      _focus={{
                        borderColor: "cyan.500",
                      }}
                      InputRightElement={
                        <IconButton
                          icon={<CloseIcon size="xs" />}
                          onPress={clearSearch}
                          variant="ghost"
                          _hover={{ bg: "transparent" }}
                        />
                      }
                    />
                  </HStack>

                  {/* Suggestions Dropdown */}
                  {searchResults.length > 0 && (
                    <Box
                      position="absolute"
                      top="100%"
                      left={0}
                      right={0}
                      bg="white"
                      borderWidth={0}
                      borderColor="gray.200"
                      borderRadius="md"
                      mt={1}
                      shadow={4}
                      zIndex={1000}
                      maxH="300px"
                      overflow="auto"
                    >
                      {searchResults.map((team) => (
                        <Pressable
                          key={team.id}
                          onPress={() => handleTeamSelect(team)}
                          p={3}
                          _hover={{ bg: "gray.50" }}
                        >
                          <HStack space={3} alignItems="center">
                            <Box
                              bg="gray.100"
                              borderRadius="full"
                              p={2}
                              width={8}
                              height={8}
                              alignItems="center"
                              justifyContent="center"
                              overflow="hidden"
                            >
                              <ProfilePic
                                width={38}
                                height={38}
                                link={
                                  currentUser?.id == team?.id
                                    ? AV.AVEntity.getLink(currentUser)
                                    : entityDataList?.find(
                                          (x: AV.IAVEntity) =>
                                            x?.id == team?.id,
                                        )
                                      ? AV.AVEntity.getLink(
                                          entityDataList?.find(
                                            (x: AV.IAVEntity) =>
                                              x?.id == team?.id,
                                          ),
                                        )
                                      : team
                                }
                              />
                            </Box>
                            <VStack>
                              <Text fontWeight="medium">{team.title}</Text>
                              {team.data && (
                                <Text fontSize="xs" color="gray.500">
                                  {team.data}
                                </Text>
                              )}
                            </VStack>
                          </HStack>
                        </Pressable>
                      ))}
                    </Box>
                  )}
                </Box>
              )}

              {/* Rest of the content with lower z-index */}
              <Box position="relative" zIndex={1}>
                <HStack
                  justifyContent="space-between"
                  alignItems="center"
                  mb={4}
                >
                  <Text fontSize="md" fontWeight="medium">
                    {Loc.currentLang.donate.selectAmount} ($)
                  </Text>
                  {!isSearching && !selectedTeam && (
                    <Button
                      variant="link"
                      _text={{ color: "cyan.500", fontSize: "md" }}
                      p={0}
                      rounded="full"
                      onPress={() => setIsSearching(true)}
                    >
                      {Loc.currentLang.donate.donateForTeam}
                    </Button>
                  )}
                </HStack>

                {/* Amount Buttons */}
                <VStack space={4}>
                  <HStack space={2} flexWrap="wrap">
                    {[
                      "$3",
                      "$5",
                      "$10",
                      "$20",
                      Loc.currentLang.activity.other,
                    ].map((amount) => (
                      <Pressable
                        key={amount}
                        onPress={() => {
                          setSelectedAmount(amount);
                          if (amount === Loc.currentLang.activity.other) {
                            setShowOtherAmount(true);
                            setCustomAmount("");
                          } else {
                            setShowOtherAmount(false);
                            setCustomAmount("");
                            setIsMinValidate(false);
                          }
                        }}
                      >
                        <Box
                          px={4}
                          py={2}
                          borderRadius="full"
                          borderWidth={1}
                          borderColor={
                            selectedAmount === amount ? "cyan.500" : "gray.200"
                          }
                          bg={selectedAmount === amount ? "cyan.50" : "white"}
                        >
                          <Text
                            fontSize="md"
                            color={
                              selectedAmount === amount
                                ? "cyan.500"
                                : "gray.600"
                            }
                          >
                            {amount}
                          </Text>
                        </Box>
                      </Pressable>
                    ))}
                  </HStack>

                  {/* Custom Amount Input */}
                  {showOtherAmount && (
                    <>
                      <AVInputtext
                        type="text"
                        label={Loc.currentLang.purchaseCredits.enterAmount}
                        onChange={(e) => {
                          const input = e.target.value.replace(/[^0-9]/g, "");
                          setCustomAmount(input);

                          if (Number(input) >= 2) {
                            setIsMinValidate(false);
                            //const credits = (Number(input) * 5000) - 2000;
                            //setSelectAmtWithCredits(credits.toString());
                          } else {
                            setIsMinValidate(true);
                            //setCustomAmount("");
                            //setSelectAmtWithCredits("");
                          }
                        }}
                        value={customAmount}
                        height={"15px"}
                        defaultValue={undefined}
                        width={undefined}
                        minRows={undefined}
                        multiline={undefined}
                        maxLength={4}
                        size={undefined}
                        placeholder={undefined}
                      />

                      {isMinValidate && (
                        <Text
                          style={{
                            color: "#FF0000",
                            fontSize: 12,
                            marginTop: 4,
                            marginLeft: 4,
                          }}
                        >
                          Minimum amount is $2
                        </Text>
                      )}
                    </>
                  )}

                  {/* Donate Button */}
                  <Button
                    backgroundColor="AVColor.primary"
                    onPress={handleDonate}
                    size="lg"
                    rounded="full"
                    isLoading={isLoadingBuy}
                    isDisabled={
                      isLoadingBuy ||
                      //!selectedTeam ||
                      isMinValidate ||
                      (selectedAmount === Loc.currentLang.activity.other &&
                        !customAmount &&
                        !isMinValidate)
                    }
                  >
                    {Loc.currentLang.menu.donate}
                  </Button>

                  {/* Info Text */}
                  <HStack space={2} alignItems="center">
                    <Image
                      source={inform}
                      alt="info"
                      width="16px"
                      height="16px"
                      opacity={0.6}
                    />
                    <Text fontSize="sm" color="gray.600">
                      {Loc.currentLang.donate.creditsInfo}
                    </Text>
                  </HStack>
                </VStack>
              </Box>
            </Box>
          </HStack>

          {/* Storage Credits Info */}
          <VStack space={1} pt={3} mt={2}>
            <Text color="green.500" fontWeight="medium" fontSize="sm">
              {Loc.currentLang.donate.storage3}
            </Text>
            <Text color="green.500" fontWeight="medium" fontSize="sm">
              {Loc.currentLang.donate.storage5}
            </Text>
          </VStack>
        </Box>
      </Box>
    </AVBody>
  );
}

export default Donate;
